import React from 'react';

import { Checkbox as OrbCheckbox, type CheckboxProps } from '@yandex-360/orb-components/dist/components/Checkbox2';

export type { CheckboxProps };

export const Checkbox = React.forwardRef<HTMLLabelElement, CheckboxProps>(
    ({ testId = 'orb-checkbox', ...props }, ref) => {
        return <OrbCheckbox testId={testId} ref={ref} {...props} />;
    }
);

Checkbox.displayName = 'Checkbox';
